// import React , { useEffect, useRef, useState } from 'react'
// import { Link, useNavigate } from 'react-router-dom';
// import LoginAPI from './LoginAPINew';
// import Registration from './RegistrationNew';
// import { useCart } from '../../Context/CartContext';
// import DualCalendar from './DualCalendar';
// import axios from 'axios';
// import { useWishlist } from '../../Context/WishlistContext';
// import './Headerscss.css';
// import ForgotPassword from './ForgotPassword';
// console.log("DEBUG IMPORTS:", { LoginAPI, Registration, DualCalendar, ForgotPassword, useCart, useWishlist, Link, useNavigate, axios });

// function Topbar({ isNavOpen, setIsNavOpen, togglerRef }) {
//   const { setUserId, clearWishlist } = useWishlist();
//   const [showCalendar, setShowCalendar] = useState(false);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [showSignUp, setShowSignUp] = useState(false);  // ✅ ADD THIS STATE
//   const dropdownRef = useRef(null);
//   const navRef = useRef(null);
//   const desktopDropdownRef = useRef(null);
//   const mobileDropdownRef = useRef(null);
//   const [selectedEvent, setSelectedEvent] = useState(null);
//   const [showForgot, setShowForgot] = useState(false);

//   // const { setUserId } = useWishlist();

//   const {
//     cartCount,
//     showLogin,
//     setShowLogin
//   } = useCart();
 
//   const [searchText, setSearchText] = useState("");
//   const navigate = useNavigate();
  
//   //suggestions state
//   const [allProducts, setAllProducts] = useState([]);
//   const [suggestions, setSuggestions] = useState([]);
  
//   useEffect(() => {
//     axios
//       .get("https://ecom.cyberathon.com/index.php/Api/list_get_product")
//       .then(res => {
//         setAllProducts(res.data.products || []);
//       })
//       .catch(err => console.log(err));
//   }, []);
  
//   //typing suggestions filter
//   const handleSearchChange = (e) => {
//     const value = e.target.value;
//     setSearchText(value);

//     if (value.length < 1) {
//       setSuggestions([]);
//       return;
//     }

//     const filtered = allProducts.filter(p =>
//       p.Product_name.toLowerCase().includes(value.toLowerCase())
//     );

//     setSuggestions(filtered.slice(0, 8)); // max 8 suggestions
//   };

//   const handleSearch = (e) => {
//     e.preventDefault();
//     if (!searchText.trim()) return;
//     navigate(`/search?query=${searchText}`);
//   };
  
//   // useEffect(() => {
//   //   const handleClickOutside = (e) => {
//   //     if (
//   //       desktopDropdownRef.current &&
//   //       !desktopDropdownRef.current.contains(e.target) &&
//   //       mobileDropdownRef.current &&
//   //       !mobileDropdownRef.current.contains(e.target)
//   //     ) {
//   //       setShowDropdown(false);
//   //     }
//   //   };
  
//   //   document.addEventListener("mousedown", handleClickOutside);
//   //   return () => document.removeEventListener("mousedown", handleClickOutside);
//   // }, []);
  
//   // ✅ FIX - no more blink
// useEffect(() => {
//   if (!isNavOpen) return;

//   const handleOutsideClick = (e) => {
//     if (
//       navRef.current &&
//       !navRef.current.contains(e.target) &&
//       togglerRef.current &&
//       !togglerRef.current.contains(e.target)
//     ) {
//       setIsNavOpen(false);
//     }
//   };

//   // ❌ REMOVE setTimeout completely
//   document.addEventListener("mousedown", handleOutsideClick);

//   return () => {
//     document.removeEventListener("mousedown", handleOutsideClick);
//   };
// }, [isNavOpen]);
//   useEffect(() => {
//     const openHandler = () => setShowLogin(true);
  
//     window.addEventListener("openLoginModal", openHandler);
  
//     return () => window.removeEventListener("openLoginModal", openHandler);
//   }, []);
  
//   const isLoggedIn = sessionStorage.getItem("isLoggedIn") === "true";
//   const fullName = sessionStorage.getItem("userName");
//   const userName = fullName ? fullName.split(" ")[0] : "Profile";
  
//   // useEffect(() => {
//   //   const handleOutsideClick = (e) => {
//   //     if (
//   //       isNavOpen &&
//   //       navRef.current &&
//   //       !navRef.current.contains(e.target) &&
//   //       !togglerRef.current.contains(e.target)
//   //     ) {
//   //       setIsNavOpen(false);
//   //     }
//   //   };
  
//   //   document.addEventListener("mousedown", handleOutsideClick);
//   //   return () => document.removeEventListener("mousedown", handleOutsideClick);
//   // }, [isNavOpen]);
  
//   // const handleLogout = () => {
//   //   sessionStorage.clear();
//   //   setUserId(null);
//   //   setShowLogin(false);
//   //   window.location.href = "/"; 
//   // };

//   // ✅ FIX - no more blink
// useEffect(() => {
//   if (!isNavOpen) return; // only attach listener when nav is open

//   const handleOutsideClick = (e) => {
//     if (
//       navRef.current &&
//       !navRef.current.contains(e.target) &&
//       togglerRef.current &&
//       !togglerRef.current.contains(e.target)  // ✅ exclude toggler clicks
//     ) {
//       setIsNavOpen(false);
//     }
//   };

//   // ✅ use setTimeout so toggler's own click doesn't immediately trigger this
//   const timer = setTimeout(() => {
//     document.addEventListener("mousedown", handleOutsideClick);
//   }, 100);

//   return () => {
//     clearTimeout(timer);
//     document.removeEventListener("mousedown", handleOutsideClick);
//   };
// }, [isNavOpen]);

//   const handleLogout = () => {
//     sessionStorage.clear();
//     setUserId(null);         // ✅ Context mein userId null karo
//     clearWishlist();         // ✅ Wishlist blank karo
//     setShowLogin(false);
//     window.location.href = "/"; 
//   }
//   return (
//     <>
//       <nav className="navbar navbar-expand-lg px-md-5 px-sm-0 backsection_col sticky-navbar ">
//         <div className="container-fluid d-flex justify-content-between align-items-center">
//           <div className="flex-shrink-0 d-none d-lg-block">
//             {/* Left side → Logo */}
//             <img src="/Images/shopLogo1.png" alt="logo" className="logoimg1 ms-0" />
//           </div>

//           {/* ================= MOBILE HEADER (NEW) ================= */}
//           <div className="d-lg-none w-100">

//             {/* ---------- ROW 1 ---------- */}
//             <div className="d-flex justify-content-between align-items-center px-2 py-0">

//               {/* Logo */}
//               <img src="/Images/shopLogo1.png" alt="logo" className="logoimg1" />

//               {/* Icons */}
//               <div className="d-flex align-items-center gap-4">

//                 {/* Profile */}
//                 <div className="position-relative mobile-nav-item" ref={mobileDropdownRef}
//                  style={{ zIndex: 100000 }}>
//                   <i
//                     className="bi bi-person icon-squaregrey2 fs-4 ms-2"
//                     style={{ cursor: "pointer" }}
//                     onClick={() => {
//                       setShowDropdown(!showDropdown);
//                       setIsNavOpen(false);
//                     }}
//                   ></i>
//                   <span className="mobile-icon-text">
//                     {isLoggedIn ? userName : "Profile"}
//                   </span>

//                   {showDropdown && (
//                     <div className="dropdown-menu mobile-profile-dropdown show p-2"
//                       style={{ right: 0, top: "30px" }}>
//                       {isLoggedIn ? (
//                         <>
//                           <Link className="dropdown-item" to="/vieworder">My Orders</Link>
//                           <Link className="dropdown-item" to="/profile">Profile</Link>
//                           <Link className="dropdown-item" to="/coupon">Coupons</Link>
//                           <Link className="dropdown-item" to="/Wishlist">Wishlist</Link>
//                           <hr />
//                           <button className="dropdown-item text-danger " onClick={handleLogout}>
//                             Logout
//                           </button>
//                         </>
//                       ) : (
//                         <button
//                           className="dropdown-item"
//                           onClick={() => {
//                             setShowLogin(true);
//                             setShowDropdown(false);
//                           }}
//                         >
//                           Login
//                         </button>
//                       )}
//                     </div>
//                   )}
//                 </div>

//                 {/* Cart */}
//                 <Link to="/functioncart" className="position-relative text-decoration-none">
//                   <i className="bi bi-cart4 icon-squaregrey3 fs-5 "></i>
//                   <span className="mobile-icon-text">Cart</span>
//                   {cartCount > 0 && (
//                     <span className="badge bg-danger position-absolute top-0 start-100 translate-middle">
//                       {cartCount}
//                     </span>
//                   )}
//                 </Link>

//                 {/* Calendar */}
//                 <div
//                   className="mobile-nav-item"
//                   onClick={() => setShowCalendar(true)}
//                 >
//                   <i className="bi bi-calendar-check icon-squaregrey3 fs-6"></i>
//                   <span className="mobile-icon-text">Calendar</span>
//                 </div>

//               </div>
//             </div>

//             {/* ---------- ROW 2 ---------- */}
//             <div className="d-flex align-items-center gap-2 px-2 pb-0 pt-1">

//               {/* Search */}
//               <form onSubmit={handleSearch} className="flex-grow-1">
//                 <div className="position-relative mobile-search-wrapper"
//                 style={{ zIndex: 9999 }} >
//                   <input
//                     className="form-control mobile-search-input"
//                     placeholder="Search Products..."
//                     value={searchText}
//                     onChange={handleSearchChange}
//                   />

//                   <button type="submit" className="mobile-search-btn">
//                     <i className="bi bi-search"></i>
//                   </button>

//                   {/* 🔽 SEARCH SUGGESTIONS */}
//                   {suggestions.length > 0 && (
//                     <div className="search-suggestions">
//                       {suggestions.map(item => (
//                         <div
//                           key={item.prod_id}
//                           className="suggestion-item"
//                           onClick={() => {
//                             navigate(`/DetailsSection3/${item.prod_id}`);
//                             setSearchText("");
//                             setSuggestions([]);
//                             setIsNavOpen(false);
//                           }}
//                         >
//                           {item.Product_name}
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               </form>

//               {/* Toggle */}
//               {/* <button
//                 ref={togglerRef}
//                 className="navbar-toggler"
//                 onClick={() => setIsNavOpen(!isNavOpen)}
//               >
//                 <span className="navbar-toggler-icon"></span>
//               </button> */}
//               <button
//   ref={togglerRef}
//   className="navbar-toggler"
//   onMouseDown={(e) => e.stopPropagation()} // ✅ ADD THIS
//   onClick={() => setIsNavOpen(prev => !prev)}
// >
//   <span className="navbar-toggler-icon"></span>
// </button>
//             </div>

//           </div>

//           {/* Collapse content */}
//           <div className=''>
//             <div
//               ref={navRef}
//               className={`navbar-collapse collapse justify-content-between widthh ${isNavOpen ? "show" : ""}`}
//             >
//               <form 
//                 onSubmit={handleSearch}
//                 className="search-form-wide d-none d-lg-flex justify-content-between7 align-items-center6"
//               >
//                 <div className="position-relative search-box ">
//                   <input
//                     className="px-3 py-2 rounded w-100 pe-5"
//                     type="text"
//                     placeholder="Search Products..."
//                     value={searchText}
//                     onChange={handleSearchChange}
//                   />
//                   <button
//                     type='submit'
//                     className="search-icon-box position-absolute end-0 top-0 bottom-0 d-flex align-items-center justify-content-center">
//                     <i className="bi bi-search text-light"></i>
//                   </button>

//                   {/* 🔽 SEARCH SUGGESTIONS */}
//                   {suggestions.length > 0 && (
//                     <div className="search-suggestions">
//                       {suggestions.map(item => (
//                         <div
//                           key={item.prod_id}
//                           className="suggestion-item"
//                           onClick={() => {
//                             navigate(`/DetailsSection3/${item.prod_id}`);
//                             setSearchText("");
//                             setSuggestions([]);
//                           }}
//                         >
//                           {item.Product_name}
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               </form>

//               {/* ✅ MOBILE NAVIGATION LINKS */}
//               <div className="d-lg-none mt-0 ">
//                 <ul className="navbar-nav gap-2 ">
//                   <li className="nav-item">
//                     <Link className="nav-link text-dark" to="/" onClick={() => setIsNavOpen(false)}>
//                       <b>Home</b>
//                     </Link>
//                   </li>
//                   <li className="nav-item">
//                     <Link className="nav-link text-dark" to="/About" onClick={() => setIsNavOpen(false)}>
//                       <b>About</b>
//                     </Link>
//                   </li>
//                   <li className="nav-item">
//                     <Link className="nav-link text-dark" to="/products" onClick={() => setIsNavOpen(false)}>
//                       <b>Product</b>
//                     </Link>
//                   </li>
//                    <li className="nav-item">
//                     <Link className="nav-link text-dark" to="/coursesection" onClick={() => setIsNavOpen(false)}>
//                       <b>Courses</b>
//                     </Link>
//                   </li>
//                   <li className="nav-item">
//                     <Link className="nav-link text-dark" to="/Ebooks" onClick={() => setIsNavOpen(false)}>
//                       <b>E-Books</b>
//                     </Link>
//                   </li>
//                   <li className="nav-item">
//                     <Link className="nav-link text-dark" to="/Blog" onClick={() => setIsNavOpen(false)}>
//                       <b>Blog</b>
//                     </Link>
//                   </li>
//                   <li className="nav-item">
//                     <Link className="nav-link text-dark" to="/ShopPage" onClick={() => setIsNavOpen(false)}>
//                       <b>Shop</b>
//                     </Link>
//                   </li>
//                   <li className="nav-item">
//                     <Link className="nav-link text-dark" to="/Testimonial" onClick={() => setIsNavOpen(false)}>
//                       <b>Testimonial</b>
//                     </Link>
//                   </li>
                  
//                  <li className="nav-item">
//                     <Link className="nav-link text-dark" to="/Contact" onClick={() => setIsNavOpen(false)}>
//                       <b>Contact</b>
//                     </Link>
//                   </li>
//                   <li className="nav-item">
//                     <Link className="nav-link text-dark" to="/faq" onClick={() => setIsNavOpen(false)}>
//                       <b>FAQ</b>
//                     </Link>
//                   </li>
//                 </ul>
//               </div>

//               {/* Right side (desktop only) → Login & Cart */}
//               <div className=" d-lg-flex d-none align-items-center justify-content-evenly gappi ">
//                 <div className="position-relative" ref={desktopDropdownRef}>

//                   <h6
//                     className="d-flex align-items-center mb-0"
//                     style={{ cursor: "pointer" }}
//                     onClick={() => setShowDropdown(!showDropdown)}
//                   >
//                     {isLoggedIn ? userName : "Profile"}
//                     <span>
//                       <i className="bi bi-person icon-squaregrey2 ms-1"></i>
//                     </span>
//                   </h6>

//                   {/* Dropdown Box */}
//                   {showDropdown && (
//                     <div
//                       className="dropdown-menu show p-2"
//                       style={{
//                         position: "absolute",
//                         top: "35px",
//                         right: 0,
//                         minWidth: "180px",
//                         boxShadow: "0px 2px 8px rgba(0,0,0,0.2)",
//                         borderRadius: "8px",
//                         background: "#fff",
//                         zIndex: 1000
//                       }}
//                     >
//                       {isLoggedIn ? (
//                         <>
//                           <Link className="dropdown-item" to="/vieworder">My Orders</Link>
//                           <Link className="dropdown-item" to="/profile">Profile Information</Link>
//                           <Link className="dropdown-item" to="/coupon">Coupons</Link>
//                           <Link className='dropdown-item' to="/Wishlist">Wishlist</Link>
//                           <hr className="my-1" />
//                           <button className="dropdown-item text-danger" onClick={handleLogout}>
//                             Logout
//                           </button>
//                         </>
//                       ) : (
//                         <>
//                           <button className="dropdown-item" onClick={() => setShowLogin(true)}>
//                             Login
//                           </button>
//                         </>
//                       )}
//                     </div>
//                   )}
//                 </div>

//                 <div>
//                   <Link to="/functioncart" className="text-decoration-none text-dark">
//                     <h6 className="d-flex align-items-center mb-0 position-relative">
//                       Cart
//                       <span className="ms-1 position-relative">
//                         <i className="bi bi-cart4 icon-squaregrey3"></i>
                  
//                         {cartCount > 0 && (
//                           <span
//                             className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
//                             style={{ fontSize: "10px" }}
//                           >
//                             {cartCount}
//                           </span>
//                         )}
//                       </span>
//                     </h6>
//                   </Link>
//                 </div>

//                 <div>
//                   <div
//                     className="position-relative me-5"
//                     style={{ cursor: "pointer" }}
//                     onClick={() => setShowCalendar(true)}
//                   >
//                     <h6 className="d-flex align-items-center mb-0">
//                       Calendar
//                       <span className="ms-1">
//                         <i className="bi bi-calendar-check icon-squaregrey3"></i>
//                       </span>
//                     </h6>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </nav>

//       {/* Calendar Popup */}
//       {/* {showCalendar && (
//         <div
//           className="calendar-popup-overlay"
//           onClick={() => setShowCalendar(false)}
//         >
//           <div
//             className="calendar-popup-box"
//             onClick={(e) => e.stopPropagation()}
//           >
            
//             <button
//               className="calendar-popup-close"
//               onClick={() => setShowCalendar(false)}
//             >
//               ✕
//             </button>

//             <DualCalendar />
//           </div>
//         </div>
//       )} */}
//       {/* Calendar Popup */}
// {showCalendar && (
//   <div
//     className="calendar-popup-overlay"
//     onClick={() => setShowCalendar(false)}
//   >
//     <div
//       className="calendar-popup-box"
//       onClick={(e) => e.stopPropagation()}
//     >
//       <button
//         className="calendar-popup-close"
//         onClick={() => setShowCalendar(false)}
//       >
//         ✕
//       </button>

//       {/* ✅ onEventSelect prop pass karo */}
//       <DualCalendar onEventSelect={setSelectedEvent} />
//     </div>
//   </div>
// )}

// {/* ✅ Modal BAHAR hai calendar-popup-box se - transform issue fix */}
// {selectedEvent && (
//   <div
//     className="modal-overlay"
//     // style={{ zIndex: 99999 }}
//       style={{ 
//       position: 'fixed',
//       inset: 0,
//       zIndex: 999999,          /* ✅ */
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       background: 'rgba(0,0,0,0.6)'
//     }}
//     onClick={() => setSelectedEvent(null)}
//   >
//     <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//       <div className="modal-header">
//         <h3 className="modal-title">{selectedEvent.title}</h3>
//         <button className="modal-close" onClick={() => setSelectedEvent(null)}>✕</button>
//       </div>
//       <div className="modal-body">
//         <div className="modal-field">
//           <div className="modal-label">Hijri Date</div>
//           <div className="modal-value">{selectedEvent.hijri_date}</div>
//         </div>
//         <div className="modal-field">
//           <div className="modal-label">Description</div>
//           <div className="modal-value">{selectedEvent.description}</div>
//         </div>
//         <div className="modal-field">
//           <div className="modal-label">Gregorian Date</div>
//           <div className="modal-value">{selectedEvent.gregorian_date}</div>
//         </div>
//       </div>
//       <button
//         className="modal-button bg-col"
//         onClick={() => setSelectedEvent(null)}
//       >
//         Close
//       </button>
//     </div>
//   </div>
// )}

//       {/* ✅ LOGIN MODAL */}
//       <LoginAPI 
//         show={showLogin} 
//         onClose={() => setShowLogin(false)}
//         openSignUp={() => {
//           setShowLogin(false);
//           setShowSignUp(true);
//         }}
//          openForgot={() => {
//     setShowLogin(false);
//     setShowForgot(true);
//   }}
//       />

//       {/* ✅ SIGNUP MODAL */}
//       <Registration
//         show={showSignUp}
//         onClose={() => setShowSignUp(false)}
//         openLogin={() => {
//           setShowSignUp(false);
//           setShowLogin(true);
//         }}
//       />
//       <ForgotPassword
//   show={showForgot}
//   onClose={() => setShowForgot(false)}
//   openLogin={() => {
//     setShowForgot(false);
//     setShowLogin(true);
//   }}
// />
//     </>
//   );
// }

// export default Topbar;
















import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LoginAPI from './LoginAPINew';
import Registration from './RegistrationNew';
import { useCart } from '../../Context/CartContext';
import DualCalendar from './DualCalendar';
import axios from 'axios';
import { useWishlist } from '../../Context/WishlistContext';
import './Headerscss.css';
import ForgotPassword from './ForgotPassword';

function Topbar({ isNavOpen, setIsNavOpen, togglerRef }) {
  const { setUserId, clearWishlist } = useWishlist();
  const [showCalendar, setShowCalendar] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);
  const dropdownRef = useRef(null);
  const navRef = useRef(null);
  const desktopDropdownRef = useRef(null);
  const mobileDropdownRef = useRef(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showForgot, setShowForgot] = useState(false);

  // ✅ NOTIFICATION - START
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [showNotifDropdown, setShowNotifDropdown] = useState(false);
  const mobileNotifRef = useRef(null);
  const desktopNotifRef = useRef(null);
  const API_BASE = "https://ecom.cyberathon.com/index.php/Api";
  // ✅ NOTIFICATION - END

  const {
    cartCount,
    showLogin,
    setShowLogin
  } = useCart();

  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();

  const [allProducts, setAllProducts] = useState([]);
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    axios
      .get("https://ecom.cyberathon.com/index.php/Api/list_get_product")
      .then(res => {
        setAllProducts(res.data.products || []);
      })
      .catch(err => console.log(err));
  }, []);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value);
    if (value.length < 1) { setSuggestions([]); return; }
    const filtered = allProducts.filter(p =>
      p.Product_name.toLowerCase().includes(value.toLowerCase())
    );
    setSuggestions(filtered.slice(0, 8));
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (!searchText.trim()) return;
    navigate(`/search?query=${searchText}`);
  };

  useEffect(() => {
    if (!isNavOpen) return;
    const handleOutsideClick = (e) => {
      if (
        navRef.current && !navRef.current.contains(e.target) &&
        togglerRef.current && !togglerRef.current.contains(e.target)
      ) {
        setIsNavOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isNavOpen]);

  useEffect(() => {
    const openHandler = () => setShowLogin(true);
    window.addEventListener("openLoginModal", openHandler);
    return () => window.removeEventListener("openLoginModal", openHandler);
  }, []);

  const isLoggedIn = sessionStorage.getItem("isLoggedIn") === "true";
  const fullName = sessionStorage.getItem("userName");
  const userName = fullName ? fullName.split(" ")[0] : "Profile";

  useEffect(() => {
    if (!isNavOpen) return;
    const handleOutsideClick = (e) => {
      if (
        navRef.current && !navRef.current.contains(e.target) &&
        togglerRef.current && !togglerRef.current.contains(e.target)
      ) {
        setIsNavOpen(false);
      }
    };
    const timer = setTimeout(() => {
      document.addEventListener("mousedown", handleOutsideClick);
    }, 100);
    return () => { clearTimeout(timer); document.removeEventListener("mousedown", handleOutsideClick); };
  }, [isNavOpen]);

  const handleLogout = () => {
    sessionStorage.clear();
    setUserId(null);
    clearWishlist();
    setShowLogin(false);
    window.location.href = "/";
  };

  // ✅ NOTIFICATION - START
  // const fetchNotifications = async () => {
  //   const userId = sessionStorage.getItem("userId");
  //   if (!userId) return;
  //   try {
  //     const res = await axios.get(`${API_BASE}/get_user_notifications?user_id=${userId}`);
  //     setNotifications(res.data.notifications || []);
  //   } catch (err) { console.log("Notif err:", err); }
  // };

  // const fetchUnreadCount = async () => {
  //   const userId = sessionStorage.getItem("userId");
  //   if (!userId) return;
  //   try {
  //     const res = await axios.get(`${API_BASE}/get_unread_notification_count?user_id=${userId}`);
  //     setUnreadCount(res.data.count || 0);
  //   } catch (err) { console.log("Count err:", err); }
  // };


  const fetchNotifications = async () => {
  const userId = sessionStorage.getItem("userId");
  if (!userId) return;
  try {
    const res = await axios.post(`${API_BASE}/get_user_notifications`, { user_id: userId });
    setNotifications(res.data.notifications || []);
  } catch (err) { console.log("Notif err:", err); }
};

const fetchUnreadCount = async () => {
  const userId = sessionStorage.getItem("userId");
  if (!userId) return;
  try {
    const res = await axios.post(`${API_BASE}/get_unread_notification_count`, { user_id: userId });
    setUnreadCount(res.data.count || 0);
  } catch (err) { console.log("Count err:", err); }
};


  const markAsRead = async (notifId) => {
    const userId = sessionStorage.getItem("userId");
    if (!userId) return;
    try {
      await axios.post(`${API_BASE}/mark_notification_read`, {
        notification_id: notifId, user_id: userId
      });
      fetchNotifications();
      fetchUnreadCount();
    } catch (err) { console.log(err); }
  };

  const markAllAsRead = async () => {
    const userId = sessionStorage.getItem("userId");
    if (!userId) return;
    try {
      await axios.post(`${API_BASE}/mark_all_notifications_read`, { user_id: userId });
      fetchNotifications();
      fetchUnreadCount();
    } catch (err) { console.log(err); }
  };

  const timeAgo = (dateStr) => {
    if (!dateStr) return "";
    const diff = Math.floor((new Date() - new Date(dateStr)) / 1000);
    if (diff < 60) return "Just now";
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
    return new Date(dateStr).toLocaleDateString();
  };

  // Notification click outside
  useEffect(() => {
    if (!showNotifDropdown) return;
    const handler = (e) => {
      if (
        mobileNotifRef.current && !mobileNotifRef.current.contains(e.target) &&
        desktopNotifRef.current && !desktopNotifRef.current.contains(e.target)
      ) {
        setShowNotifDropdown(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [showNotifDropdown]);

  // Fetch on login
  useEffect(() => {
    if (isLoggedIn) { fetchNotifications(); fetchUnreadCount(); }
    else { setNotifications([]); setUnreadCount(0); }
  }, [isLoggedIn]);

  // Refresh on open
  useEffect(() => {
    if (showNotifDropdown && isLoggedIn) { fetchNotifications(); fetchUnreadCount(); }
  }, [showNotifDropdown]);

  // Notification dropdown JSX
  const NotifDropdown = ({ cls }) => (
    <div className={cls}>
      <div className="notif-dropdown-header">
        <span className="notif-dropdown-title">Notifications</span>
        {unreadCount > 0 && (
          <button className="notif-mark-all" onClick={(e) => { e.stopPropagation(); markAllAsRead(); }}>
            Mark all read
          </button>
        )}
      </div>
      <div className="notif-dropdown-body">
        {notifications.length === 0 ? (
          <div className="notif-empty">
            <i className="bi bi-bell-slash" style={{ fontSize: "28px", color: "#ccc", display: "block", marginBottom: "8px" }}></i>
            No notifications yet
          </div>
        ) : (
          notifications.slice(0, 10).map(n => (
            <div
              key={n.id}
              className={`notif-item ${n.is_read == 0 ? 'notif-unread' : ''}`}
              onClick={() => markAsRead(n.id)}
            >
              <div className="notif-item-title">{n.title}</div>
              <div className="notif-item-msg">{n.message}</div>
              <div className="notif-item-time">{timeAgo(n.created_at)}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
  // ✅ NOTIFICATION - END

  return (
    <>
      <nav className="navbar navbar-expand-lg px-md-5 px-sm-0 backsection_col sticky-navbar">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <div className="flex-shrink-0 d-none d-lg-block">
            <img src="/Images/shopLogo1.png" alt="logo" className="logoimg1 ms-0" />
          </div>

          {/* ================= MOBILE HEADER ================= */}
          <div className="d-lg-none w-100">
            {/* ROW 1 */}
            <div className="d-flex justify-content-between align-items-center px-2 py-0">
              <img src="/Images/shopLogo1.png" alt="logo" className="logoimg1" />
              <div className="d-flex align-items-center gap-4">

                {/* Profile */}
                <div className="position-relative mobile-nav-item" ref={mobileDropdownRef} style={{ zIndex: 100000 }}>
                  <i className="bi bi-person icon-squaregrey2 fs-4 ms-2" style={{ cursor: "pointer" }}
                    onClick={() => { setShowDropdown(!showDropdown); setIsNavOpen(false); }}></i>
                  <span className="mobile-icon-text">{isLoggedIn ? userName : "Profile"}</span>
                  {showDropdown && (
                    <div className="dropdown-menu mobile-profile-dropdown show p-2" style={{ right: 0, top: "30px" }}>
                      {isLoggedIn ? (
                        <>
                          <Link className="dropdown-item" to="/vieworder">My Orders</Link>
                          <Link className="dropdown-item" to="/profile">Profile</Link>
                          <Link className="dropdown-item" to="/coupon">Coupons</Link>
                          <Link className="dropdown-item" to="/Wishlist">Wishlist</Link>
                          <hr />
                          <button className="dropdown-item text-danger" onClick={handleLogout}>Logout</button>
                        </>
                      ) : (
                        <button className="dropdown-item" onClick={() => { setShowLogin(true); setShowDropdown(false); }}>Login</button>
                      )}
                    </div>
                  )}
                </div>

                {/* Cart */}
                <Link to="/functioncart" className="position-relative text-decoration-none">
                  <i className="bi bi-cart4 icon-squaregrey3 fs-5"></i>
                  <span className="mobile-icon-text">Cart</span>
                  {cartCount > 0 && (
                    <span className="badge bg-danger position-absolute top-0 start-100 translate-middle">{cartCount}</span>
                  )}
                </Link>

                {/* Calendar */}
                <div className="mobile-nav-item" onClick={() => setShowCalendar(true)}>
                  <i className="bi bi-calendar-check icon-squaregrey3 fs-6"></i>
                  <span className="mobile-icon-text">Calendar</span>
                </div>

                {/* ✅ NOTIFICATION BELL - Mobile */}
                {/* <div className="position-relative" ref={mobileNotifRef} style={{ zIndex: 100000 }}>
                  <div className="mobile-nav-item"
                    onClick={() => {
                      if (!isLoggedIn) { setShowLogin(true); return; }
                      setShowNotifDropdown(!showNotifDropdown);
                      setIsNavOpen(false);
                    }}>
                    <span className="position-relative" style={{ display: "inline-block" }}>
                      <i className="bi bi-bell icon-squaregrey3 fs-5" style={{ cursor: "pointer" }}></i>
                      {unreadCount > 0 && (
                        <span className="notif-badge-mobile">{unreadCount > 9 ? "9+" : unreadCount}</span>
                      )}
                    </span>
                  </div>
                  {showNotifDropdown && <NotifDropdown cls="notification-dropdown-mobile" />}
                </div> */}


                {/* ✅ NOTIFICATION BELL - Mobile */}
<div className="position-relative mobile-nav-item" ref={mobileNotifRef} style={{ zIndex: 100000 }}>
  <div
    onClick={() => {
      if (!isLoggedIn) { setShowLogin(true); return; }
      setShowNotifDropdown(!showNotifDropdown);
      setIsNavOpen(false);
    }}>
    <span className="position-relative" style={{ display: "inline-block" }}>
      <i className="bi bi-bell icon-squaregrey3 fs-5" style={{ cursor: "pointer" }}></i>
      {unreadCount > 0 && (
        <span className="notif-badge-mobile">{unreadCount > 9 ? "9+" : unreadCount}</span>
      )}
    </span>
  </div>
  <span className="mobile-icon-text">Notify</span>
  {showNotifDropdown && <NotifDropdown cls="notification-dropdown-mobile" />}
</div>

              </div>
            </div>

            {/* ROW 2 */}
            <div className="d-flex align-items-center gap-2 px-2 pb-0 pt-1">
              <form onSubmit={handleSearch} className="flex-grow-1">
                <div className="position-relative mobile-search-wrapper" style={{ zIndex: 9999 }}>
                  <input className="form-control mobile-search-input" placeholder="Search Products..."
                    value={searchText} onChange={handleSearchChange} />
                  <button type="submit" className="mobile-search-btn"><i className="bi bi-search"></i></button>
                  {suggestions.length > 0 && (
                    <div className="search-suggestions">
                      {suggestions.map(item => (
                        <div key={item.prod_id} className="suggestion-item"
                          onClick={() => { navigate(`/DetailsSection3/${item.prod_id}`); setSearchText(""); setSuggestions([]); setIsNavOpen(false); }}>
                          {item.Product_name}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </form>
              <button ref={togglerRef} className="navbar-toggler"
                onMouseDown={(e) => e.stopPropagation()}
                onClick={() => setIsNavOpen(prev => !prev)}>
                <span className="navbar-toggler-icon"></span>
              </button>
            </div>
          </div>

          {/* Collapse content */}
          <div className=''>
            <div ref={navRef}
              className={`navbar-collapse collapse justify-content-between widthh ${isNavOpen ? "show" : ""}`}>

              {/* Desktop Search */}
              <form onSubmit={handleSearch} className="search-form-wide d-none d-lg-flex justify-content-between7 align-items-center6">
                <div className="position-relative search-box">
                  <input className="px-3 py-2 rounded w-100 pe-5" type="text" placeholder="Search Products..."
                    value={searchText} onChange={handleSearchChange} />
                  <button type='submit' className="search-icon-box position-absolute end-0 top-0 bottom-0 d-flex align-items-center justify-content-center">
                    <i className="bi bi-search text-light"></i>
                  </button>
                  {suggestions.length > 0 && (
                    <div className="search-suggestions">
                      {suggestions.map(item => (
                        <div key={item.prod_id} className="suggestion-item"
                          onClick={() => { navigate(`/DetailsSection3/${item.prod_id}`); setSearchText(""); setSuggestions([]); }}>
                          {item.Product_name}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </form>

              {/* Mobile Nav Links */}
              <div className="d-lg-none mt-0">
                <ul className="navbar-nav gap-2">
                  <li className="nav-item"><Link className="nav-link text-dark" to="/" onClick={() => setIsNavOpen(false)}><b>Home</b></Link></li>
                  <li className="nav-item"><Link className="nav-link text-dark" to="/About" onClick={() => setIsNavOpen(false)}><b>About</b></Link></li>
                  <li className="nav-item"><Link className="nav-link text-dark" to="/products" onClick={() => setIsNavOpen(false)}><b>Product</b></Link></li>
                  <li className="nav-item"><Link className="nav-link text-dark" to="/coursesection" onClick={() => setIsNavOpen(false)}><b>Courses</b></Link></li>
                  <li className="nav-item"><Link className="nav-link text-dark" to="/Ebooks" onClick={() => setIsNavOpen(false)}><b>E-Books</b></Link></li>
                  <li className="nav-item"><Link className="nav-link text-dark" to="/Blog" onClick={() => setIsNavOpen(false)}><b>Blog</b></Link></li>
                  <li className="nav-item"><Link className="nav-link text-dark" to="/ShopPage" onClick={() => setIsNavOpen(false)}><b>Shop</b></Link></li>
                  <li className="nav-item"><Link className="nav-link text-dark" to="/Testimonial" onClick={() => setIsNavOpen(false)}><b>Testimonial</b></Link></li>
                  <li className="nav-item"><Link className="nav-link text-dark" to="/Contact" onClick={() => setIsNavOpen(false)}><b>Contact</b></Link></li>
                  <li className="nav-item"><Link className="nav-link text-dark" to="/faq" onClick={() => setIsNavOpen(false)}><b>FAQ</b></Link></li>
                </ul>
              </div>

              {/* Desktop Right Side */}
              <div className="d-lg-flex d-none align-items-center justify-content-evenly gappi">
                {/* Profile */}
                <div className="position-relative" ref={desktopDropdownRef}>
                  <h6 className="d-flex align-items-center mb-0" style={{ cursor: "pointer" }}
                    onClick={() => setShowDropdown(!showDropdown)}>
                    {isLoggedIn ? userName : "Profile"}
                    <span><i className="bi bi-person icon-squaregrey2 ms-1"></i></span>
                  </h6>
                  {showDropdown && (
                    <div className="dropdown-menu show p-2" style={{
                      position: "absolute", top: "35px", right: 0, minWidth: "180px",
                      boxShadow: "0px 2px 8px rgba(0,0,0,0.2)", borderRadius: "8px", background: "#fff", zIndex: 1000
                    }}>
                      {isLoggedIn ? (
                        <>
                          <Link className="dropdown-item" to="/vieworder">My Orders</Link>
                          <Link className="dropdown-item" to="/profile">Profile Information</Link>
                          <Link className="dropdown-item" to="/coupon">Coupons</Link>
                          <Link className='dropdown-item' to="/Wishlist">Wishlist</Link>
                          <hr className="my-1" />
                          <button className="dropdown-item text-danger" onClick={handleLogout}>Logout</button>
                        </>
                      ) : (
                        <button className="dropdown-item" onClick={() => setShowLogin(true)}>Login</button>
                      )}
                    </div>
                  )}
                </div>

                {/* Cart */}
                <div>
                  <Link to="/functioncart" className="text-decoration-none text-dark">
                    <h6 className="d-flex align-items-center mb-0 position-relative">
                      Cart
                      <span className="ms-1 position-relative">
                        <i className="bi bi-cart4 icon-squaregrey3"></i>
                        {cartCount > 0 && (
                          <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: "10px" }}>
                            {cartCount}
                          </span>
                        )}
                      </span>
                    </h6>
                  </Link>
                </div>

                {/* Calendar */}
                <div>
                  <div className="position-relative " style={{ cursor: "pointer" }} onClick={() => setShowCalendar(true)}>
                    <h6 className="d-flex align-items-center mb-0">
                      Calendar
                      <span className="ms-1"><i className="bi bi-calendar-check icon-squaregrey3"></i></span>
                    </h6>
                  </div>
                </div>

                {/* ✅ NOTIFICATION BELL - Desktop */}
                {/* <div className="position-relative" ref={desktopNotifRef}>
                  <div style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (!isLoggedIn) { setShowLogin(true); return; }
                      setShowNotifDropdown(!showNotifDropdown);
                    }}>
                    <span className="position-relative" style={{ display: "inline-block" }}>
                      <i className="bi bi-bell icon-squaregrey3"></i>
                      {unreadCount > 0 && (
                        <span className="notif-badge-desktop">{unreadCount > 9 ? "9+" : unreadCount}</span>
                      )}
                    </span>
                  </div>
                  {showNotifDropdown && <NotifDropdown cls="notification-dropdown-desktop" />}
                </div> */}


                {/* ✅ NOTIFICATION BELL - Desktop */}
<div className="position-relative" ref={desktopNotifRef}>
  <h6
    className="d-flex align-items-center mb-0"
    style={{ cursor: "pointer" }}
    onClick={() => {
      if (!isLoggedIn) { setShowLogin(true); return; }
      setShowNotifDropdown(!showNotifDropdown);
    }}>
    Notify
    <span className="ms-1 position-relative">
      <i className="bi bi-bell icon-squaregrey3"></i>
      {unreadCount > 0 && (
        <span className="notif-badge-desktop">{unreadCount > 9 ? "9+" : unreadCount}</span>
      )}
    </span>
  </h6>
  {showNotifDropdown && <NotifDropdown cls="notification-dropdown-desktop" />}
</div>

              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Calendar Popup */}
      {showCalendar && (
        <div className="calendar-popup-overlay" onClick={() => setShowCalendar(false)}>
          <div className="calendar-popup-box" onClick={(e) => e.stopPropagation()}>
            <button className="calendar-popup-close" onClick={() => setShowCalendar(false)}>✕</button>
            <DualCalendar onEventSelect={setSelectedEvent} />
          </div>
        </div>
      )}

      {/* Event Modal */}
      {selectedEvent && (
        <div className="modal-overlay" style={{
          position: 'fixed', inset: 0, zIndex: 999999,
          display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.6)'
        }} onClick={() => setSelectedEvent(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">{selectedEvent.title}</h3>
              <button className="modal-close" onClick={() => setSelectedEvent(null)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="modal-field"><div className="modal-label">Hijri Date</div><div className="modal-value">{selectedEvent.hijri_date}</div></div>
              <div className="modal-field"><div className="modal-label">Description</div><div className="modal-value">{selectedEvent.description}</div></div>
              <div className="modal-field"><div className="modal-label">Gregorian Date</div><div className="modal-value">{selectedEvent.gregorian_date}</div></div>
            </div>
            <button className="modal-button bg-col" onClick={() => setSelectedEvent(null)}>Close</button>
          </div>
        </div>
      )}

      {/* Login Modal */}
      <LoginAPI show={showLogin} onClose={() => setShowLogin(false)}
        openSignUp={() => { setShowLogin(false); setShowSignUp(true); }}
        openForgot={() => { setShowLogin(false); setShowForgot(true); }} />

      {/* Signup Modal */}
      <Registration show={showSignUp} onClose={() => setShowSignUp(false)}
        openLogin={() => { setShowSignUp(false); setShowLogin(true); }} />

      {/* Forgot Password Modal */}
      <ForgotPassword show={showForgot} onClose={() => setShowForgot(false)}
        openLogin={() => { setShowForgot(false); setShowLogin(true); }} />
    </>
  );
}

export default Topbar;